<!doctype html>
@if (showProjectLoadingScreen) {
  <div id="loading_screen">
    <div style="margin: auto; display: inline-flex; flex-direction: column; height: 600px">
      <div style="margin: auto; display: inline-flex; flex-direction: row; width: 1100px">
        <div style="display: inline-flex; flex: 1 1 auto; margin: auto">
          <div
            class="loading_option_container bg-primary cursor-pointer"
            (click)="loadData('fast')"
            [ngClass]="loadDataConfig === 'fast' ? 'selected' : ''"
          >
            <div class="loading_option">
              <div class="loading_option_header">
                <h4 style="margin: auto">Schnelle Planung</h4>
              </div>
              <hr style="border-color: white; width: 100%; margin: 0" />
              <div class="loading_option_footer">
                <div style="margin: auto">Es werden keine offenen Aufträge und Tickets geladen.</div>
              </div>
            </div>
          </div>
        </div>
        <div style="display: inline-flex; flex: 1 1 auto; margin: auto">
          <div
            class="loading_option_container bg-primary cursor-pointer"
            (click)="loadDataConfig = 'projects'"
            [ngClass]="loadDataConfig === 'projects' ? 'selected' : ''"
          >
            <div class="loading_option">
              <div class="loading_option_header">
                <h4 style="margin: auto">Projektauswahl</h4>
              </div>
              <hr style="border-color: white; width: 100%; margin: 0" />
              <div class="loading_option_footer">
                <div style="margin: auto">Es werden projektspezifische Aufträge und Tickets geladen.</div>
              </div>
            </div>
          </div>
        </div>
        <div style="display: inline-flex; flex: 1 1 auto; margin: auto">
          <div
            class="loading_option_container bg-primary cursor-pointer"
            (click)="loadData('all_except_internal_project')"
            [ngClass]="loadDataConfig === 'all' ? 'selected' : ''"
          >
            <div class="loading_option">
              <div class="loading_option_header">
                <h4 style="margin: auto">Alles laden</h4>
              </div>
              <hr style="border-color: white; width: 100%; margin: 0" />
              <div class="loading_option_footer">
                <div style="margin: auto">Alle offenen Aufträge und Tickets werden geladen.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="margin: auto; display: inline-flex; flex-direction: row; width: 1100px">
        <div id="selected_projects_container" [ngClass]="loadDataConfig === 'projects' ? 'shown' : ''">
          <div
            class="bg-secondary cursor-pointer"
            style="
              width: 100%;
              border: 1px solid black;
              display: inline-flex;
              flex-direction: row;
              flex-wrap: nowrap;
              padding: 2px 4px;
            "
          >
            <div style="margin: auto">
              <input
                class="bg-base-100"
                style="float: left"
                type="text"
                placeholder="Projekt suchen..."
                [(ngModel)]="projectNameFilter"
              />
            </div>
            <div style="flex: 1; margin-top: auto; margin-bottom: auto">
              <div style="float: right">
                <mat-button-toggle-group [(ngModel)]="serviceProjectsToggleGroup">
                  <mat-button-toggle value="service" (change)="selectAllServiceProjects()">Service</mat-button-toggle>
                  <mat-button-toggle value="non_service" (change)="selectAllNonServiceProjects()"
                    >Nicht-Service</mat-button-toggle
                  >
                </mat-button-toggle-group>
              </div>
            </div>
            <div style="height: 100%; display: inline-flex; margin: auto">
              <div style="margin: auto; color: white; padding: 2px 4px">
                Projekte ausgewählt: {{ selectedProjectsToLoad.length }}
              </div>
            </div>
          </div>
          <div
            style="
              height: 100%;
              max-width: 100%;
              max-height: 300px;
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;
              overflow-y: auto;
              background-color: #444444;
            "
          >
            @for (project of PADataControl.Instance.loadedProjectFilteredByName(projectNameFilter); track project) {
              <div
                (click)="toggleProjectToLoad(project)"
                class="black_gradient_background project"
                [ngClass]="selectedProjectsToLoad.includes(project) ? 'selected' : ''"
              >
                {{ project.project_name }}
              </div>
            }
            @if (!PADataControl.Instance.loadedProjectFilteredByName(projectNameFilter).length) {
              <div style="padding: 2px 4px; margin: auto; color: white">Keine Projekte gefunden</div>
            }
          </div>
        </div>
        @if (projectLoadingConfigSelected() && projectsLoaded) {
          <div
            id="start_button"
            class="bg-primary cursor-pointer"
            (click)="loadData('projects')"
            style="margin: auto; border: 1px solid black"
          >
            <h4 style="margin-bottom: 0; padding: 8px 32px; border-radius: 8px; color: white">weiter</h4>
          </div>
        }
      </div>
    </div>
  </div>
}

<div id="planning_assistant_container" [ngClass]="screenfull.isFullscreen ? 'fullscreen' : ''" class="card">
  <div id="main_window" [ngClass]="screenfull.isFullscreen ? 'fullscreen' : ''">
    <hawk-popup-modal
      [shown]="PASettingsControl.Instance.showSettings"
      (closeEvent)="PASettingsControl.Instance.showSettings = false"
    >
      <hawk-pa-settings (updateWeekdaysEvent)="updateWeekdaysInCalendar($event)"> </hawk-pa-settings>
    </hawk-popup-modal>
    <div style="flex: 1; position: relative; display: inline-flex; flex-direction: row-reverse; overflow: visible">
      <pa-popout-window #popoutWindow1 style="overflow: visible; display: inline-flex; flex-direction: column">
        <div
          class="tour_planner_container transparent_black_gradient_background"
          [ngClass]="popoutWindow1.isPoppedOut ? 'external_window' : ''"
        >
          <div
            class="planning_tabs bg-secondary"
            [ngClass]="popoutWindow1?.isPoppedOut ? 'dark_background' : ''"
            style="overflow: visible"
          >
            <div class="tab-header bg-primary">
              <div [ngClass]="selectedPlanningTab === 'manual' ? 'active' : ''" (click)="selectedPlanningTab = 'manual'">
                <i class="fa fa-pen"></i>
                Planung
              </div>
              <div
                [ngClass]="selectedPlanningTab === 'changes' ? 'active' : ''"
                (click)="selectedPlanningTab = 'changes'"
              >
                <i class="fa fa-code-merge"></i>
                Änderungen
                {{
                  PADataControl.Instance.operationChanges.length
                    ? "(" + PADataControl.Instance.operationChanges.length + ")"
                    : ""
                }}
              </div>
            </div>
            <div [ngClass]="selectedPlanningTab === 'manual' ? 'shift_0' : 'shift_1'" class="tab-indicator"></div>
            <div class="tab-body" style="overflow: visible">
              <div [ngClass]="selectedPlanningTab === 'manual' ? 'active' : ''" style="overflow: visible">
                <hawk-tourplanner-menu
                  style="overflow: visible"
                  [planningMode]="PATourPlannerControl.Instance.tourPlannerPlanningMode"
                  [planningInstructions]="PATourPlannerControl.Instance.planningInstructions"
                  [operations]="PAFilterControl.Instance.filteredUnplannedOperations"
                  [technicians]="PAFilterControl.Instance.globalFilteredTechnicians"
                  [shownCalendarWeeksData]="PATimeControl.Instance.shownCalendarWeeksData"
                  [selectedCalendarWeekData]="PATimeControl.Instance.selectedCalendarWeekData"
                  [selectedCalendarDay]="PATimeControl.Instance.selectedCalendarDay"
                  [selectedOperationID]="PATourPlannerControl.Instance.operationToPlanID"
                  [selectedTechnicianID]="PATourPlannerControl.Instance.technicianToPlanID"
                  [filteredWeekdays]="PAFilterControl.Instance.filteredWeekDays"
                  [operationTimeFilter]="PAFilterControl.Instance.selectedOperationTimeFilter"
                  [showTechnicianDatesForTechnicians]="PAFilterControl.Instance.preferredCalendarTechnicians"
                  [showOverviewForTechnicianDateCollections]="
                    PATourPlannerControl.Instance.tourPlannerOverviewTechnicianDateCollections
                  "
                  [extraOperationCollection]="PATourPlannerControl.Instance.tourPlannerExtraOperationCollection"
                  [externalWindow]="popoutWindow1"
                  [projectMode]="PASettingsControl.Instance.projectMode"
                  [filteredProjects]="PAFilterControl.Instance.selectedProjects"
                  (updatePreferredTechniciansEvent)="updatePreferredTechnicians($event)"
                >
                </hawk-tourplanner-menu>
              </div>
              <!--<div [ngClass]="selectedPlanningTab == 'automatic' ? 'active' : ''">
              <hawk-optiwae-connector style="user-select: none;"
              [technicians]="PADataControl.Instance.loadedTechnicians"></hawk-optiwae-connector>
            </div>-->
              <div [ngClass]="selectedPlanningTab === 'changes' ? 'active' : ''">
                <hawk-save-menu
                  [ngClass]="popoutWindow1?.isPoppedOut ? 'horizontal_flex' : 'vertical_flex'"
                  [externalWindow]="popoutWindow1"
                  [operationChanges]="PADataControl.Instance.operationChanges"
                  [lastChangeTimeStamp]="PATourPlannerControl.Instance.lastOperationChangeTimeStamp"
                >
                </hawk-save-menu>
              </div>
            </div>
          </div>
        </div>
      </pa-popout-window>
      <div
        style="
          position: relative;
          flex: 1;
          display: inline-flex;
          flex-direction: column;
          flex-wrap: nowrap;
          overflow: hidden;
        "
      >
        <div style="display: inline-flex; flex-direction: column; flex: 1">
          <div style="display: inline-flex; flex-direction: row">
            @if (Store.selectedStoreInMap && Store.selectedStoreInMap.selectedStoreOperation) {
              <div id="store_operation_view_container">
                <!-- <div class="store_overview_section" [tooltip]="'zeige erledigte Aufträge'">
              <div style="margin: auto;">
                <fa-icon
                  (click)="toggleSelectedStoreHideDoneOperation()"
                  class="clickable_symbol" style="font-size: 1rem; line-height: 0px;"
                  [ngClass]="!Store.selectedStoreInMap.hideDoneOperations? 'selected' : ''"
                [icon]="faCheck"></fa-icon>
              </div>
            </div> -->
                <div style="text-align: center; position: relative; display: inline-flex; font-size: 0.8rem">
                  <div style="display: inline-flex; flex-direction: row; flex-wrap: nowrap">
                    <hawk-expand-bar-header
                      [description]="Store.selectedStoreInMap?.operationTree?.header || 'Keine Aufträge'"
                      [isExpanded]="showStoreOperations"
                      [fontSize]="'.8rem'"
                      [height]="'100%'"
                      [fontColor]="'#18b9f8'"
                      (toggle)="showStoreOperations = $event"
                    >
                    </hawk-expand-bar-header>
                    <div
                      class="store_overview_section bg-primary"
                      style="flex: 1"
                      [tooltip]="Store.selectedStoreInMap.address"
                    >
                      <div style="margin: auto; white-space: nowrap">
                        {{ Store.selectedStoreInMap.address_company }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="expand black_gradient_background_no_hover"
                    style="position: absolute; z-index: 50; left: 0; top: 100%; overflow-x: hidden; min-width: 420px"
                    [ngClass]="showStoreOperations ? '' : 'hidden'"
                  >
                    @if (Store.selectedStoreInMap?.operationTree?.unplanned?.length) {
                      <hawk-icon-expand-bar
                        [description]="'Ungeplant'"
                        [isExpanded]="Store.selectedStoreInMap?.expandUnplannedProjects"
                        [fontSize]="'.8rem'"
                        [height]="'100%'"
                        [leftAligned]="true"
                        [fontColor]="'#ffffff'"
                        (toggle)="Store.selectedStoreInMap.expandUnplannedProjects = $event"
                      >
                        @for (
                          project_subtree of Store.selectedStoreInMap.operationTree.unplanned;
                          track project_subtree
                        ) {
                          <div content>
                            <hawk-icon-expand-bar
                              [description]="
                                project_subtree.project.project_name +
                                ' (' +
                                project_subtree.project_operations?.length +
                                ')'
                              "
                              [isExpanded]="
                                Store.selectedStoreInMap?.expandStoreProjects.includes(project_subtree.project)
                              "
                              (toggle)="Store.selectedStoreInMap.toggleExpandProject(project_subtree.project, $event)"
                            >
                              <hawk-store-operations
                                content
                                [operations]="project_subtree.project_operations"
                                [selectedOperation]="Store.selectedStoreInMap.selectedStoreOperation"
                                (selectStoreOperationEvent)="PAStoreControl.Instance.selectStoreOperation($event)"
                              >
                              </hawk-store-operations>
                              <div icon style="margin: auto; display: inline-flex">
                                <div
                                  [style.background-color]="project_subtree.project.color"
                                  class="project_color_circle"
                                  style="color: black; display: inline-flex; line-height: 0"
                                >
                                  <div style="margin: auto; line-height: 0"></div>
                                </div>
                              </div>
                            </hawk-icon-expand-bar>
                          </div>
                        }
                        <div icon style="margin: auto; display: inline-flex">
                          <div
                            [style.background-color]="'white'"
                            class="project_color_circle"
                            style="color: black; display: inline-flex; line-height: 0"
                          >
                            <div style="margin: auto; line-height: 0">N</div>
                          </div>
                        </div>
                      </hawk-icon-expand-bar>
                    }
                    @if (Store.selectedStoreInMap?.operationTree?.planned?.length) {
                      <hawk-icon-expand-bar
                        [description]="'Geplant'"
                        [isExpanded]="Store.selectedStoreInMap?.expandPlannedProjects"
                        [fontSize]="'.8rem'"
                        [height]="'100%'"
                        [leftAligned]="true"
                        [fontColor]="'#ffffff'"
                        (toggle)="Store.selectedStoreInMap.expandPlannedProjects = $event"
                      >
                        @for (
                          project_subtree of Store.selectedStoreInMap.operationTree.planned;
                          track project_subtree
                        ) {
                          <div content>
                            <hawk-icon-expand-bar
                              [description]="
                                project_subtree.project.project_name +
                                ' (' +
                                project_subtree.project_operations.length +
                                ')'
                              "
                              [isExpanded]="
                                Store.selectedStoreInMap?.expandStoreProjects.includes(project_subtree.project)
                              "
                              (toggle)="Store.selectedStoreInMap.toggleExpandProject(project_subtree.project, $event)"
                            >
                              <hawk-store-operations
                                content
                                [operations]="project_subtree.project_operations"
                                [selectedOperation]="Store.selectedStoreInMap.selectedStoreOperation"
                                (selectStoreOperationEvent)="PAStoreControl.Instance.selectStoreOperation($event)"
                              >
                              </hawk-store-operations>
                              <div icon style="margin: auto; display: inline-flex">
                                <div
                                  [style.background-color]="project_subtree.project.color"
                                  class="project_color_circle"
                                  style="color: black; display: inline-flex; line-height: 0"
                                >
                                  <div style="margin: auto; line-height: 0"></div>
                                </div>
                              </div>
                            </hawk-icon-expand-bar>
                          </div>
                        }
                        <div icon style="margin: auto; display: inline-flex">
                          <fa-icon [icon]="faCalendar"></fa-icon>
                        </div>
                      </hawk-icon-expand-bar>
                    }
                    @if (Store.selectedStoreInMap?.operationTree?.done?.length) {
                      <hawk-icon-expand-bar
                        [description]="'Erledigt'"
                        [isExpanded]="Store.selectedStoreInMap?.expandDoneProjects"
                        [fontSize]="'.8rem'"
                        [height]="'100%'"
                        [leftAligned]="true"
                        [fontColor]="'#ffffff'"
                        (toggle)="Store.selectedStoreInMap.expandDoneProjects = $event"
                      >
                        @for (project_subtree of Store.selectedStoreInMap.operationTree.done; track project_subtree) {
                          <div content>
                            <hawk-icon-expand-bar
                              [description]="
                                project_subtree.project.project_name +
                                ' (' +
                                project_subtree.project_operations.length +
                                ')'
                              "
                              [isExpanded]="
                                Store.selectedStoreInMap?.expandStoreProjects.includes(project_subtree.project)
                              "
                              (toggle)="Store.selectedStoreInMap.toggleExpandProject(project_subtree.project, $event)"
                            >
                              <hawk-store-operations
                                content
                                [operations]="project_subtree.project_operations"
                                [selectedOperation]="Store.selectedStoreInMap.selectedStoreOperation"
                                (selectStoreOperationEvent)="PAStoreControl.Instance.selectStoreOperation($event)"
                              >
                              </hawk-store-operations>
                              <div icon style="margin: auto; display: inline-flex">
                                <div
                                  [style.background-color]="project_subtree.project.color"
                                  class="project_color_circle"
                                  style="color: black; display: inline-flex; line-height: 0"
                                >
                                  <div style="margin: auto; line-height: 0"></div>
                                </div>
                              </div>
                            </hawk-icon-expand-bar>
                          </div>
                        }
                        <div icon style="display: inline-flex; margin: auto">
                          <div>&#10004;</div>
                        </div>
                      </hawk-icon-expand-bar>
                    }
                  </div>
                </div>
                <div class="bg-primary" style="display: inline-flex; flex-direction: row; flex: 1 1 auto">
                  @if (Store.selectedStoreInMap?.selectedStoreOperation) {
                    <div class="store_overview_section bg-primary" style="flex: 1 1 auto; flex-direction: row">
                      <div
                        style="
                          display: inline-flex;
                          flex-direction: row;
                          padding: 2px 4px;
                          flex-wrap: wrap;
                          white-space: nowrap;
                          font-size: 0.8rem;
                          height: 100%;
                        "
                      >
                        <div style="padding: 2px; margin: auto">
                          T:
                          @if (Store.selectedStoreInMap.selectedStoreOperation.ticket.id >= 0) {
                            <a
                              href="/a/ticket/{{
                                Store.selectedStoreInMap.selectedStoreOperation.ticket.id
                              }}?operation_id={{ Store.selectedStoreInMap.selectedStoreOperation.id }}"
                              target="_blank"
                              >{{ Store.selectedStoreInMap.selectedStoreOperation.ticket.id }}</a
                            >
                          }
                          @if (Store.selectedStoreInMap.selectedStoreOperation.ticket.id < 0) {
                            NEU
                          }
                        </div>
                        <div style="margin: auto; white-space: nowrap; padding: 2px">
                          {{ Store.selectedStoreInMap.selectedStoreOperation.ticket.project.project_name }}
                        </div>
                        <div
                          style="margin: auto; white-space: nowrap; padding: 2px"
                          [style.color]="Store.selectedStoreInMap.selectedStoreOperation.ticket.priority.color"
                        >
                          {{ Store.selectedStoreInMap.selectedStoreOperation.ticket.priority.name }}
                        </div>
                        <div
                          style="margin: auto; white-space: nowrap; padding: 2px"
                          [style.color]="Store.selectedStoreInMap.selectedStoreOperation.ticket.status?.color"
                        >
                          ({{ Store.selectedStoreInMap.selectedStoreOperation.ticket.status?.name }})
                        </div>
                        @if (
                          Store.selectedStoreInMap.selectedStoreOperation.slaDateInformation() ||
                          Store.selectedStoreInMap.selectedStoreOperation.ticket.memos?.length
                        ) {
                          <div style="display: inline-flex; flex-direction: row; padding: 2px">
                            @if (Store.selectedStoreInMap.selectedStoreOperation.slaDateInformation()) {
                              <div
                                class="info_marker"
                                [tooltip]="Store.selectedStoreInMap.selectedStoreOperation.slaDateInformation()"
                              >
                                <b>SLA!</b>
                              </div>
                            }
                            @if (Store.selectedStoreInMap.selectedStoreOperation.ticket.memos?.length) {
                              <div
                                class="info_marker"
                                [tooltip]="Store.selectedStoreInMap.selectedStoreOperation.ticket.memos.join(' | ')"
                              >
                                <b>Memos!</b>
                              </div>
                            }
                          </div>
                        }
                      </div>
                      <div
                        style="
                          padding: 2px;
                          border-left: 1px solid black;
                          flex: 1;
                          white-space: normal;
                          font-size: 0.8rem;
                          display: inline-flex;
                        "
                        [tooltip]="
                          Store.selectedStoreInMap.selectedStoreOperation.description.length > 100
                            ? Store.selectedStoreInMap.selectedStoreOperation.description
                            : null
                        "
                      >
                        <div style="margin: auto">
                          {{
                            Store.selectedStoreInMap.selectedStoreOperation.description.length > 100
                              ? Store.selectedStoreInMap.selectedStoreOperation.description.slice(0, 100) + "..."
                              : Store.selectedStoreInMap.selectedStoreOperation.description
                          }}
                        </div>
                      </div>
                    </div>
                  }
                </div>
                <div class="store_overview_section bg-primary" style="position: relative; width: 25px">
                  <button
                    (click)="PAStoreControl.Instance.closeStoreMenu()"
                    class="cancel_button"
                    style="text-align: center; z-index: 10"
                  >
                    <fa-icon [icon]="faWindowClose" style="color: white"></fa-icon>
                  </button>
                </div>
              </div>
            }
            @if (popoutWindow1?.isPoppedOut) {
              <div class="store_overview_section" style="width: 304px; background-color: #444444"></div>
            }
          </div>
          <div style="display: inline-flex; flex-direction: row; flex: 1">
            <div style="position: relative; flex: 1; border: 1px solid black">
              <hawk-map
                [technicians]="PATourPlannerControl.Instance.shownMapTechnicians"
                [operations]="PATourPlannerControl.Instance.shownMapOperations"
                [tourPlannerExtraOperations]="PATourPlannerControl.Instance.tourPlannerExtraOperationCollection"
                [drivingIsoDistance]="PAMapControl.Instance.isochroneDistance"
                [shownRoutes]="PATourPlannerControl.Instance.shownRoutes"
                [selectedIsoCoordinates]="PAMapControl.Instance.selectedIsoCoordinates"
                [mapBoxAccessToken]="mapBoxLoadingService.accessToken"
                [technicianDistanceType]="PATourPlannerControl.Instance.technicianDistanceType"
                [tourPlannerPlanningMode]="PATourPlannerControl.Instance.tourPlannerPlanningMode"
              >
              </hawk-map>
            </div>
            <div
              class="side_menu"
              [ngClass]="
                PATourPlannerControl.Instance.tourPlannerOverviewTechnicianDateCollections.length &&
                PASettingsControl.Instance.selectedSettingConfig.data.general.map.seperated_tour_view
                  ? 'visible'
                  : ''
              "
            >
              <hawk-tour-comparison
                style="display: inline-flex; flex: 1; flex-direction: column; user-select: none"
                #TourComparison
                [mapBoxAccessToken]="mapBoxLoadingService.accessToken"
                [planningInstructions]="PATourPlannerControl.Instance.planningInstructions"
                [operations]="PAFilterControl.Instance.filteredUnplannedOperations"
                [filteredWeekdays]="PAFilterControl.Instance.filteredWeekDays"
                [technicianDateCollections]="PATourPlannerControl.Instance.tourPlannerOverviewTechnicianDateCollections"
              >
              </hawk-tour-comparison>
            </div>
          </div>
        </div>

        <div style="display: inline-flex; flex-direction: row; overflow: visible">
          <hawk-filter
            #filterComponent
            style="flex: 1; display: inline-flex"
            id="filter_component"
            [technicians]="PADataControl.Instance.loadedTechnicians"
            [operations]="PADataControl.Instance.loadedOperations"
          >
          </hawk-filter>
          <div id="progress_section_container" [ngClass]="popoutWindow1?.isPoppedOut ? 'popped_out_mode' : ''">
            <hawk-loading-container style="display: inline-flex; flex: 1"></hawk-loading-container>
          </div>
        </div>
      </div>

      <button
        [ngClass]="popoutWindow1.isPoppedOut ? 'popped_out_mode' : ''"
        [tooltip]="'Einstellungen'"
        class="settings_button bm-btn bm-btn-primary"
        (click)="openSettings()"
      >
        <fa-icon [icon]="faCog"></fa-icon>
      </button>

      <div class="reload_menu_container">
        <button
          [ngClass]="popoutWindow1.isPoppedOut ? 'popped_out_mode' : ''"
          [tooltip]="'Neu Laden'"
          class="reload_button bm-btn bm-btn-primary"
          (click)="quickReloadPage()"
        >
          <span style="font-size: 1.3rem" class="reload">&#x21bb;</span>
        </button>
        <div class="reload_menu">
          <fieldset class="bm-fieldset bm-card-body">
            <legend class="bm-fieldset-legend bm-card-title">Einstellungen fürs Neu-Laden</legend>

            <label class="bm-input">
              <input
                class="bm-checkbox"
                type="checkbox"
                [(ngModel)]="PASettingsControl.Instance.selectedSettingConfig.data.general.reload.projects"
              />
              <span class="bm-label w-32">Projektauswahl übernehmen</span>
            </label>
            <label class="bm-input">
              <input
                class="bm-checkbox"
                type="checkbox"
                [(ngModel)]="PASettingsControl.Instance.selectedSettingConfig.data.general.reload.operations"
              />
              <span class="bm-label w-32">Auftragsverbund übernehmen</span>
            </label>
            <label class="bm-input">
              <input
                class="bm-checkbox"
                type="checkbox"
                [(ngModel)]="PASettingsControl.Instance.selectedSettingConfig.data.general.reload.technicians"
              />
              <span class="bm-label w-32">Ausgewählte Techniker übernehmen</span>
            </label>
            <label class="bm-input">
              <input
                class="bm-checkbox"
                type="checkbox"
                [(ngModel)]="PASettingsControl.Instance.selectedSettingConfig.data.general.reload.days"
              />
              <span class="bm-label w-32">Geöffnete Kalendertage übernehmen</span>
            </label>
            <div class="horizontal_flex" style="margin: 12px 0 0 0">
              <button class="bm-btn" (click)="saveSettingsAndReloadPage()">
                Einstellungen speichern und Seite neu laden
              </button>
            </div>
          </fieldset>
        </div>
      </div>

      @if (!popoutWindow1?.isPoppedOut) {
        <button
          [tooltip]="'Planungsmenü in neuem Fenster öffnen'"
          class="popout_button bm-btn bm-btn-primary"
          (click)="popOut(popoutWindow1)"
        >
          <fa-icon [icon]="faExternalLinkAlt"></fa-icon>
        </button>
      }

      <button
        [tooltip]="'Vollbild'"
        class="fullscreen_button bm-btn bm-btn-primary"
        [ngClass]="popoutWindow1.isPoppedOut ? 'popped_out_mode' : ''"
        (click)="toggleFullscreen()"
      >
        @if (screenfull.isFullscreen) {
          <fa-icon [icon]="faCompress"></fa-icon>
        }
        @if (!screenfull.isFullscreen) {
          <fa-icon [icon]="faExpand"></fa-icon>
        }
      </button>

      <div id="geocoder" class="geocoder" [ngClass]="popoutWindow1.isPoppedOut ? 'popped_out_mode' : ''"></div>
    </div>

    <div id="calendar_container">
      <hawk-calendar
        style="overflow: visible"
        [technicians]="PAFilterControl.Instance.globalFilteredTechnicians"
        [operationTimeFilter]="PAFilterControl.Instance.selectedOperationTimeFilter"
        [filteredWeekdays]="PAFilterControl.Instance.filteredWeekDays"
        [shownCalendarWeeksData]="PATimeControl.Instance.shownCalendarWeeksData"
        [selectedCalendarWeekData]="PATimeControl.Instance.selectedCalendarWeekData"
        [selectedCalendarDay]="PATimeControl.Instance.selectedCalendarDay"
        [preferredTechnicians]="PAFilterControl.Instance.preferredCalendarTechnicians"
        (addPreferredTechnicianEvent)="addPreferredTechnician($event)"
        (removePreferredTechnicianEvent)="removePreferredTechnician($event)"
      >
      </hawk-calendar>
    </div>
  </div>
</div>

@if (PADataControl.Instance.operationsWithoutLngLat.length) {
  <div
    style="
      position: absolute;
      top: 0;
      left: 0;
      z-index: 200;
      width: 100%;
      height: 100%;
      background-color: rgba(94, 0, 0, 0.849);
    "
  >
    <hawk-insufficient-data-popup
      [operationsWithoutLngLat]="PADataControl.Instance.operationsWithoutLngLat"
      [mapboxAccessToken]="mapBoxLoadingService.accessToken"
    ></hawk-insufficient-data-popup>
  </div>
}

<hawk-popup-modal (closeEvent)="setStateTechnician = null" [shown]="!!setStateTechnician">
  <div class="h-full d-flex flex-column">
    <hawk-set-technician-state
      [technician]="setStateTechnician"
      (closeComponent)="setStateTechnician = null"
    ></hawk-set-technician-state>
  </div>
</hawk-popup-modal>

<!-- Meldungen (Ersatz für die frühere Material-Snackbar) -->
<hawk-pa-notifications />

<!-- Debug-Fenster zur Tourenberechnung: Kopieren/Speichern der letzten Aufzeichnung -->
<hawk-tour-debug-dialog />
